import Vue from 'vue';
import ElementUI from 'element-ui';
import 'normalize.css'; // normalize
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';
import { sync } from 'vuex-router-sync';
import VueParticles from 'vue-particles';
import FlagIcon from 'vue-flag-icon';
import Icon from 'vue-awesome/components/Icon.vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Firebase from './fireBaseInit';
import Default from './layouts/Default.vue';
import Login from './layouts/Login.vue';

Vue.component('default-layout', Default);
Vue.component('login-layout', Login);

let app;

sync(store, router);
Vue.component('icon', Icon);
Vue.config.productionTip = false;
Vue.use(VueParticles);
Vue.use(ElementUI, { locale });
Vue.use(FlagIcon);


// Wait with initializing the Vue app until we are sure Firebase is initialized.
Firebase.auth.onAuthStateChanged((user) => {
  if (user) {
    store.dispatch('saveUser', user);
    Firebase.fireStoreDB.collection('users').doc(user.uid).set({
      name: user.displayName,
      email: user.email,
      photoUrl: user.photoURL,
      phoneNumber: user.phoneNumber,
    }).catch((error) => {
      console.error(error);
    });
  }

  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app');
  }
});
